import React from 'react'
import injectSheet from 'react-jss'
import styles from './child.styles'
import { PobbleAvatar } from 'pobble-components/dist/pobble-avatar'
import { Cell } from 'pobble-components/dist/table'
import Button from 'pobble-components/dist/button'
import { openConfirmationDialog } from 'pobble-components/dist/modal/confirmation-dialog'

const Child = ({ classes, id, userId, name, avatar, permission, onRemove }) => {
  return (
    <tr>
      <Cell className={classes.student}>
        <PobbleAvatar avatar={avatar} name={name} className={classes.avatar} />
        <a href={`/students/${id}`} className={classes.name}>
          {name}
        </a>
      </Cell>
      <Cell className={classes.actions}>
        <Button
          simple
          tall
          action={() =>
            openConfirmationDialog({
              bodyText: `You are about to remove this child from your profile. You cannot reverse this.`,
              confirmText: 'Remove access',
              action: () => onRemove(id, userId)
            })
          }>
          Remove
        </Button>
      </Cell>
    </tr>
  )
}

export default injectSheet(styles)(Child)
